// src/TaxonomyMultiSelect.jsx
import React, { useMemo, useState } from 'react';

export default function TaxonomyMultiSelect({
  title,
  items,
  selectedCodes,
  onToggle,
  groupByCategory = true,
  small = false
}) {
  const [q, setQ] = useState('');

  const filtered = useMemo(() => {
    if (!q.trim()) return items;
    const s = q.trim().toLowerCase();
    return items.filter(i =>
      (i.label || '').toLowerCase().includes(s) ||
      (i.code  || '').toLowerCase().includes(s)
    );
  }, [items, q]);

  const grouped = useMemo(() => {
    if (!groupByCategory) return { all: filtered };
    return filtered.reduce((acc, it) => {
      const key = it.category || 'other';
      if (!acc[key]) acc[key] = [];
      acc[key].push(it);
      return acc;
    }, {});
  }, [filtered, groupByCategory]);

  return (
    <div className="border rounded p-2 bg-white">
      {title && <div className="text-sm font-semibold mb-2">{title}</div>}
      <div className="max-h-56 overflow-auto space-y-2">
        {Object.entries(grouped).map(([cat, list]) => (
          <div key={cat}>
            {groupByCategory && <div className="text-xs font-semibold text-slate-500 mb-1 uppercase">{cat}</div>}
            <div className="grid grid-cols-1 sm:grid-cols-2 gap-1">
              {list.map(it => {
                const sel = selectedCodes.has(it.code);
                return (
                  <label key={it.code} className="flex items-center gap-2 text-sm cursor-pointer">
                    <input
                      type="checkbox"
                      checked={sel}
                      onChange={() => onToggle(it.code)}
                    />
                    <span className={sel ? 'font-medium' : ''}>
                      {it.label} <span className="text-xs text-slate-500">({it.code})</span>
                    </span>
                  </label>
                );
              })}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}


